import React from 'react'
import { Col, Row } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { NFTextInput } from '../../../Shared/NewForms/NFTextInput'
import { NFDateInput } from '../../../Shared/NewForms/NFDateInput'

const DriverDetailMain = () => {
  const {t} = useTranslation()
  return (
    <>
         <Row>
            <Col sm={6}>
              <NFTextInput title={t("Name")} fieldName={"name"} />
            </Col>
            <Col sm={6}>
              <NFTextInput title={t("UniqueCode")} fieldName={"uniqueCode"} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFDateInput title={t("CreatedDate")} fieldName={"createdDate"} />
            </Col>
            <Col sm={6}>
              <NFTextInput title={t("LastName")} fieldName={"lastName"} />
            </Col>
          </Row>
          <Row>
            <Col sm={6}>
              <NFTextInput title={t("firstName")} fieldName={"firstName"} />
            </Col>
          </Row>
    </>
  )
}

export default DriverDetailMain